<template>
	<div class="warehouse-page">
		<div class="container">

			<!-- KPI 概览 -->
			<div class="kpi-row">
				<div class="kpi-card" v-for="(kpi, i) in kpiList" :key="i">
					<div class="kpi-label">{{ kpi.label }}</div>
					<div class="kpi-value"><countTo :startVal='0' :endVal='kpi.value' separator="" :duration='3000'
							:decimals="kpi.value % 1 === 0 ? 0 : 1"></countTo><span class="kpi-unit">{{ kpi.unit }}</span></div>
					<div class="kpi-sub">{{ kpi.desc }}</div>
					<div class="detail-btn" v-if="kpi.label && kpi.label.indexOf('接入数据源') !== -1" @click="flowVisible = true">详情</div>
				</div>
			</div>

			<!-- 中部：分层架构 + 图表 -->
			<div class="mid-row">
				<div class="panel">
					<div class="panel-title"><span class="dot"></span>{{ warehouseTitle }}</div>
					<div class="layer-stack">
						<div class="layer" :class="layer.className" v-for="layer in layers" :key="layer.code">
							<div class="layer-name">{{ layer.name }}</div>
							<div class="layer-desc">{{ layer.desc }}</div>
							<div class="layer-stat"><b>{{ layer.tableCount }}</b>{{ layer.unit }}</div>
						</div>
					</div>
				</div>

				<div class="panel">
					<div class="panel-title"><span class="dot"></span>{{ distributionTitle }}</div>
					<div ref="themeChart" class="chart-box"></div>
				</div>
			</div>

			<!-- 主题库卡片 -->
			<div class="panel">
				<div class="panel-title"><span class="dot"></span>{{ themeTitle }}</div>
				<div class="theme-grid">
					<div class="theme-card" v-for="item in themeList" :key="item.index">
						<div class="theme-head">
							<div class="theme-name">{{ item.name }}</div>
							<div class="theme-badge" :class="item.badgeClass">{{ item.tag }}</div>
						</div>
						<div class="theme-stats">
							<span><b>{{ item.volume.value }}</b>{{ item.volume.unit }}</span>
							<span><b>{{ item.tableCount }}</b>表</span>
							<span><b>{{ item.scale.display }}</b>{{ item.scale.label }}</span>
						</div>
						<div class="theme-items">{{ item.fields }}</div>
					</div>
				</div>
			</div>

			<!-- 数据接入来源 / 数据服务输出：默认隐藏，点击顶部“详情”弹窗展示 -->
			<div class="flow-mask" v-if="flowVisible" @click.self="flowVisible = false">
				<div class="flow-dialog">
					<div class="flow-dlg-head">
						<div class="panel-title" style="margin-bottom:0;"><span class="dot"></span>接入数据源 · 数据服务输出</div>
						<div class="flow-dlg-close" @click="flowVisible = false">×</div>
					</div>
					<div class="flow-row">
						<div class="panel">
							<div class="panel-title"><span class="dot"></span>{{ dataSourcesTitle }}</div>
							<div class="flow-side">
								<div class="flow-item" v-for="(group, i) in dataSourceGroups" :key="i"><span class="name">{{ group.name }}</span><span
										class="cnt">{{ group.display }}</span></div>
							</div>
						</div>
						<div class="panel">
							<div class="panel-title"><span class="dot"></span>{{ dataServicesTitle }}</div>
							<div class="flow-side">
								<div class="flow-item out" v-for="(service, i) in dataServiceItems" :key="i"><span class="name">{{ service.name
										}}</span><span class="cnt">{{ service.display }}</span></div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import countTo from 'vue-count-to'

	export default {
		components: {
			countTo
		},
		data() {
			return {
				pieTimer: null,
				pieIndex: -1,
				// 以下配置数据从字典（参数配置）获取，key：行业数据仓大屏
				kpiList: [],
				warehouseTitle: '',
				layers: [],
				distributionTitle: '',
				distributionItems: [],
				themeTitle: '',
				themeList: [],
				dataSourcesTitle: '',
				dataSourceGroups: [],
				dataServicesTitle: '',
				dataServiceItems: [],
				flowVisible: false
			}
		},
		created() {
			this.getConfig()
		},
		mounted() {
			this.initThemeChart()
			window.addEventListener('resize', this.resizeThemeChart)
		},
		beforeDestroy() {
			clearInterval(this.pieTimer)
			window.removeEventListener('resize', this.resizeThemeChart)
			if (this.themeChart) {
				this.themeChart.dispose()
				this.themeChart = null
			}
		},
		methods: {
			// 读取参数配置并渲染页面
			getConfig() {
				this.$request2('/admin-api/infra/config/get-value-by-key?key=' + encodeURIComponent('行业数据仓大屏')).then(res => {
					if (!res || res.code !== 0 || !res.data) {
						console.warn('行业数据仓配置获取失败', res && res.msg)
						return
					}
					let cfg = null
					try {
						cfg = JSON.parse(res.data)
					} catch (e) {
						console.warn('行业数据仓配置不是合法 JSON', e)
						return
					}
					this.kpiList = [cfg.stats.totalDataVolume].concat(cfg.stats.items)
					this.warehouseTitle = cfg.warehouse.title
					this.layers = cfg.warehouse.layers
					this.distributionTitle = cfg.themeDataDistribution.title
					this.distributionItems = cfg.themeDataDistribution.items
					this.themeTitle = cfg.themeLibraries.title
					this.themeList = cfg.themeLibraries.items
					this.dataSourcesTitle = cfg.dataSources.title
					this.dataSourceGroups = cfg.dataSources.groups
					this.dataServicesTitle = cfg.dataServices.title
					this.dataServiceItems = cfg.dataServices.items
					this.initThemeChart()
					this.startPieLoop()
				})
			},
			// 主题库数据量分布饼图
			initThemeChart() {
				if (!this.$refs.themeChart) return
				if (!this.themeChart) {
					this.themeChart = echarts.init(this.$refs.themeChart)
				}
				this.themeChart.setOption({
					tooltip: {
						trigger: 'item',
						backgroundColor: 'rgba(0,40,100,0.9)',
						borderColor: '#00d4ff',
						textStyle: { color: '#fff' }
					},
					legend: {
						orient: 'vertical',
						right: 10,
						top: 'center',
						textStyle: { color: '#9fd8ff', fontSize: 11 },
						itemWidth: 10,
						itemHeight: 10
					},
					series: [{
						type: 'pie',
						radius: ['40%', '68%'],
						center: ['38%', '50%'],
						label: { show: false },
						itemStyle: { borderColor: '#050e2a', borderWidth: 2 },
						emphasis: {
							scale: true,
							scaleSize: 8,
							itemStyle: { shadowBlur: 12, shadowColor: 'rgba(0, 212, 255, 0.6)' }
						},
						data: this.distributionItems.map(item => ({
							value: item.value,
							name: item.name,
							itemStyle: { color: item.color }
						}))
					}]
				})
			},
			// 扇区轮询高亮，每隔2秒切换到下一块并弹出提示
			startPieLoop() {
				clearInterval(this.pieTimer)
				const dataLen = this.distributionItems.length
				if (!dataLen) return
				this.pieIndex = -1
				this.pieTimer = setInterval(() => {
					if (!this.themeChart) return
					if (this.pieIndex >= 0) {
						this.themeChart.dispatchAction({ type: 'downplay', seriesIndex: 0, dataIndex: this.pieIndex })
					}
					this.pieIndex = (this.pieIndex + 1) % dataLen
					this.themeChart.dispatchAction({ type: 'highlight', seriesIndex: 0, dataIndex: this.pieIndex })
					this.themeChart.dispatchAction({ type: 'showTip', seriesIndex: 0, dataIndex: this.pieIndex })
				}, 2000)
			},
			resizeThemeChart() {
				if (this.themeChart) this.themeChart.resize()
			}
		}
	}
</script>

<style scoped lang="scss">
	/* 行业数据仓页面：背景由大屏主页面提供，此处只放内容 */
	.warehouse-page {
		position: absolute;
		top: 102px;
		right: 0;
		left: 0;
		bottom: 0;
		overflow-y: auto;
		color: #cfe8ff;
		font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
	}

	.container {
		position: relative;
		z-index: 1;
		padding: 16px 20px 30px;
		display: grid;
		grid-template-columns: 1fr;
		gap: 14px;
	}

	/* KPI 行 */
	.kpi-row {
		display: grid;
		grid-template-columns: repeat(6, 1fr);
		gap: 14px;
	}

	.kpi-card {
		background: linear-gradient(180deg, rgba(0, 60, 140, 0.4), rgba(0, 30, 80, 0.3));
		border: 1px solid rgba(0, 180, 255, 0.3);
		border-radius: 6px;
		padding: 14px 18px;
		position: relative;
		overflow: hidden;
	}

	.kpi-card::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 3px;
		height: 100%;
		background: #00d4ff;
		box-shadow: 0 0 8px #00d4ff;
	}

	.kpi-label {
		font-size: 13px;
		color: #7fb8e8;
		margin-bottom: 6px;
	}

	.kpi-value {
		font-size: 28px;
		font-weight: bold;
		color: #ffd700;
		text-shadow: 0 0 10px rgba(255, 215, 0, 0.4);
		font-family: "DIN Alternate", "Microsoft YaHei", sans-serif;
	}

	.kpi-unit {
		font-size: 13px;
		color: #7fb8e8;
		margin-left: 4px;
	}

	.kpi-sub {
		font-size: 11px;
		color: #5a9fd8;
		margin-top: 4px;
	}

	/* 中部两栏 */
	.mid-row {
		display: grid;
		grid-template-columns: 1.2fr 1fr;
		gap: 14px;
	}

	.panel {
		background: linear-gradient(180deg, rgba(0, 50, 120, 0.35), rgba(0, 25, 70, 0.25));
		border: 1px solid rgba(0, 180, 255, 0.25);
		border-radius: 6px;
		padding: 14px;
	}

	.panel-title {
		font-size: 16px;
		font-weight: bold;
		color: #fff;
		padding-left: 10px;
		border-left: 3px solid #00d4ff;
		margin-bottom: 12px;
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.panel-title .dot {
		width: 8px;
		height: 8px;
		background: #00d4ff;
		border-radius: 50%;
		box-shadow: 0 0 8px #00d4ff;
	}

	/* 数仓分层 */
	.layer-stack {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.layer {
		display: grid;
		grid-template-columns: 100px 1fr 120px;
		gap: 12px;
		align-items: center;
		padding: 10px 14px;
		background: rgba(0, 80, 180, 0.15);
		border-left: 3px solid;
		border-radius: 0 4px 4px 0;
		position: relative;
	}

	.layer.ads { border-color: #ff6b6b; background: rgba(255, 107, 107, 0.08); }
	.layer.dws { border-color: #ffd700; background: rgba(255, 215, 0, 0.08); }
	.layer.dwd { border-color: #00d4ff; background: rgba(0, 212, 255, 0.08); }
	.layer.ods { border-color: #4ade80; background: rgba(74, 222, 128, 0.08); }

	.layer-name {
		font-size: 15px;
		font-weight: bold;
	}

	.layer.ads .layer-name { color: #ff6b6b; }
	.layer.dws .layer-name { color: #ffd700; }
	.layer.dwd .layer-name { color: #00d4ff; }
	.layer.ods .layer-name { color: #4ade80; }

	.layer-desc {
		font-size: 12px;
		color: #9fd8ff;
		line-height: 1.5;
	}

	.layer-stat {
		text-align: right;
		font-size: 12px;
		color: #7fb8e8;
	}

	.layer-stat b {
		display: block;
		font-size: 18px;
		color: #fff;
	}

	/* 右侧图表区 */
	.chart-box {
		height: 260px;
	}

	/* 主题库卡片 */
	.theme-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 12px;
	}

	.theme-card {
		background: linear-gradient(180deg, rgba(0, 70, 160, 0.3), rgba(0, 35, 90, 0.2));
		border: 1px solid rgba(0, 180, 255, 0.25);
		border-radius: 6px;
		padding: 12px;
		transition: all 0.2s;
	}

	.theme-card:hover {
		border-color: #00d4ff;
		box-shadow: 0 0 15px rgba(0, 212, 255, 0.3);
		transform: translateY(-2px);
	}

	.theme-head {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 8px;
	}

	.theme-name {
		font-size: 14px;
		font-weight: bold;
		color: #fff;
	}

	.theme-badge {
		font-size: 10px;
		padding: 2px 8px;
		border-radius: 10px;
		background: rgba(0, 212, 255, 0.15);
		color: #00d4ff;
		border: 1px solid rgba(0, 212, 255, 0.4);
	}

	.theme-badge.hot {
		background: rgba(255, 107, 107, 0.15);
		color: #ff6b6b;
		border-color: rgba(255, 107, 107, 0.4);
	}

	.theme-stats {
		display: flex;
		gap: 14px;
		font-size: 11px;
		color: #7fb8e8;

		b {
			color: #ffd700;
			font-size: 14px;
			margin-right: 2px;
		}
	}

	.theme-items {
		margin-top: 8px;
		font-size: 11px;
		color: #9fd8ff;
		line-height: 1.6;
	}

	/* 底部数据流向 */
	.flow-row {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 14px;
	}

	.flow-side {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.flow-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 8px 12px;
		background: rgba(0, 80, 180, 0.15);
		border-left: 2px solid #4ade80;
		border-radius: 0 4px 4px 0;
		font-size: 12px;

		&.out {
			border-left-color: #ff6b6b;
		}

		.name {
			color: #cfe8ff;
		}

		.cnt {
			color: #ffd700;
			font-weight: bold;
		}
	}

	/* 接入数据源卡片右上角详情按钮 */
	.detail-btn {
		position: absolute;
		top: 10px;
		right: 12px;
		font-size: 12px;
		color: #00d4ff;
		border: 1px solid rgba(0, 212, 255, 0.5);
		background: rgba(0, 212, 255, 0.12);
		border-radius: 12px;
		padding: 1px 10px;
		cursor: pointer;
		transition: all 0.2s;
		z-index: 2;
	}

	.detail-btn:hover {
		background: rgba(0, 212, 255, 0.25);
		box-shadow: 0 0 10px rgba(0, 212, 255, 0.4);
	}

	/* 详情弹窗 */
	.flow-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(3, 10, 26, 0.72);
		z-index: 2000;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.flow-dialog {
		width: 86%;
		max-width: 1200px;
		max-height: 80vh;
		overflow: auto;
		padding: 16px 18px;
		background: linear-gradient(180deg, rgba(0, 40, 100, 0.96), rgba(0, 20, 60, 0.96));
		border: 1px solid rgba(0, 180, 255, 0.4);
		border-radius: 8px;
		box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5), 0 0 24px rgba(0, 180, 255, 0.25);
	}

	.flow-dlg-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 12px;
	}

	.flow-dlg-close {
		width: 28px;
		height: 28px;
		line-height: 26px;
		text-align: center;
		font-size: 18px;
		color: #9fd8ff;
		border: 1px solid rgba(0, 180, 255, 0.4);
		border-radius: 4px;
		cursor: pointer;
	}

	.flow-dlg-close:hover {
		color: #fff;
		background: rgba(255, 77, 106, 0.3);
	}
</style>
